import menuInit from './menu';
import navbarInit from './navbar';
import stickyHeader from './stickyHeader';
import searchBarInit from './searchBar';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }

  if (document.getElementsByClassName('podcast').length) {
    import('./podcast').then((module) => module.default());
  }

  if (document.getElementsByClassName('projects--filter').length) {
    import('./postfilters').then((module) => module.default());
  }

  if (document.getElementsByClassName('vacancies').length) {
    import('./vacanciesFilter').then((module) => module.default());
  }

  if (document.getElementsByClassName('employees__loadmore').length) {
    import('./loadmore').then((module) => module.default());
  }

  if (document.getElementsByClassName('search-results').length) {
    import('./searchBarActive').then((module) => module.default());
  }

  if (document.getElementsByClassName('search-no-results').length) {
    import('./searchBarActive').then((module) => module.default());
  }

  if (document.getElementsByClassName('employees').length) {
    import('./employee-mobile-scroll-animation').then((module) => module.default());
  }

  if (document.getElementsByClassName('sticky-vacancy-bar').length) {
    import('./vacancy-bar').then((module) => module.default());
  }

  if (document.getElementsByClassName('employees').length) {
    import('./show-phone-number').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();
  stickyHeader();
  searchBarInit();
});
